var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.554C15 2.22836 14.7497 1.96527 14.44 1.96527H11.5V0.787808C11.5 0.730468 11.4684 0.680513 11.4226 0.65625C11.4078 0.6484 11.3915 0.64324 11.3743 0.641389C11.3696 0.640884 11.3648 0.640626 11.36 0.640625C11.36 0.640625 11.36 0.640625 11.36 0.640625L10.38 0.640625C10.303 0.640625 10.24 0.706857 10.24 0.787808V1.96527H5.76V0.787808C5.76 0.706857 5.697 0.640625 5.62 0.640625H4.64C4.563 0.640625 4.5 0.706857 4.5 0.787808V1.96527H1.56C1.25025 1.96527 1 2.22836 1 2.554V14.7702C1 15.0958 1.25025 15.3589 1.56 15.3589H14.44C14.7498 15.3589 15 15.0958 15 14.7702L15 2.554ZM13.74 14.0343V7.04309H2.26V14.0343H13.74Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5033 8.98435C10.7852 8.70249 10.7849 8.24583 10.5034 7.96437C10.222 7.68292 9.76532 7.68265 9.48347 7.96451L8.00009 9.44788L6.51649 7.96428C6.23504 7.68282 5.77838 7.68256 5.49652 7.96442C5.21466 8.24628 5.21493 8.70293 5.49638 8.98439L6.97999 10.468L5.55383 11.8942C5.27197 12.176 5.27223 12.6327 5.55369 12.9141C5.83514 13.1956 6.2918 13.1958 6.57366 12.914L7.99982 11.4878L9.42629 12.9143C9.70774 13.1958 10.1644 13.196 10.4463 12.9142C10.7281 12.6323 10.7279 12.1756 10.4464 11.8942L9.01993 10.4677L10.5033 8.98435Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelAppointment);
export default __webpack_public_path__ + "static/media/cancel_appointment.3aadc2dec37d152ffd627c49eef6c1a0.svg";
export { ForwardRef as ReactComponent };